export const SECURITY_BASE = 'security/SECURITY_BASE';
export const SECURITY_CSRF_TOKEN_SET = 'security/SECURITY_CSRF_TOKEN_SET';
